import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import GroupMemberService from '../../../Services/UserGroup/GroupMemberService';
import AddGroupMembershipItem from '../../../Domain/UserGroup/AddGroupMembershipItem';

export default class AddGroupMembersWindowDescription {
  static titleForCreate = 'Add Group Members';
  static titleForEdit = 'Add Group Members';
  static itemType = AddGroupMembershipItem;
  static serviceFunction = (item) => GroupMemberService.AddGroupMembers(item);

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'UserIds',
          label: 'Users *',
          className: 'col-12',
          type: InputTypesEnum.UserMultiSelect,
          validityChecker: ValidityHelper.forRequiredMultiSelectField,
        },
      ],
    },
  ];
}
